// A call to action that may lead away (sign-up) or down the page (the contact form,
// when the owner has closed signups). A hash has to stay a plain anchor: the page's
// smooth scroll listens for those, and a router Link would change the URL and not move.

import { Link } from "react-router-dom";

export default function CtaLink({ href, children, ...rest }) {
    if (String(href).startsWith("/")) return <Link to={href} {...rest}>{children}</Link>;
    return <a href={href} {...rest}>{children}</a>;
}
